import { ChatRoom } from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';

export default function ChatRoomListSkeleton() {
  return (
    <>
      {makeIndexArray(7).map((el) => (
        <ChatRoom key={el} />
      ))}
    </>
  );
}
